export class DynamicFormFieldOption {
  public label!: string;
  public value!: string | number | boolean;
  public tooltip?: string;
  public parentItemId?: number;
  public disabled?: boolean;
}
